export default function () {
  const widgetName = 'videoWidgetSecond';
  const widgetOpts = videoWidgetSecondOpts;

  $('#videoWidgetSecondWrapper').append('<div id="videoWidget" class="videoWidgetSecond"></div>');
  $(`.${widgetName}`).append('<iframe></iframe>');
  $(`.${widgetName}`).wrap('<div id="videoSection"></div>');


  $(`.${widgetName}`).videoWidget({
    scriptPath: widgetOpts.scriptPath
    , currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID
    , detectIpad: IPADDETECTED
    // options
    , multiVideo: false
    , showOnMobile: true
    , autoPlayVideo: true
    , maxVideos: 1


    , videoWidgetLoaded: function (data) {
      if (data.Slides.length < 1) {
        $('#videoWidgetSecondWrapper').remove();
        $('#seoBlock').addClass('novideoLoaded');
        $('.tier-4-container').addClass('centerContent');
      }
    }
  });

};
